import { LOCAL_STORAGE_KEYS } from 'utils/constants/common'

export const getDeviceId = async function () {
  let deviceId = localStorage.getItem(LOCAL_STORAGE_KEYS.DEVICE_ID)

  if (deviceId && deviceId !== 'null') {
    return deviceId
  } else {
    deviceId = await generateDeviceId()

    localStorage.setItem(LOCAL_STORAGE_KEYS.DEVICE_ID, deviceId)
    return deviceId
  }
}

export const generateDeviceId = async function () {
  // Collect basic browser information
  const components = [
    navigator.userAgent, // Browser and operating system
    navigator.language, // Browser language
    screen.width, // Screen width
    screen.height, // Screen height
    screen.colorDepth, // Color depth
    new Date().getTimezoneOffset() // Timezone
  ]

  // Concatenate the information to create a base string
  const rawString = components.join('::')

  // Generate hash using SHA-256
  const hashBuffer = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(rawString)
  )

  // Convert the hash to a hexadecimal string
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
